import React, { useEffect, useState } from "react";
import { GridActionsCellItem, GridColDef } from "@mui/x-data-grid";
import SearchIcon from "@mui/icons-material/Search";
import { toast } from "react-toastify";
import { Card as MuiCard, Grid, Modal, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import OlogaPageHeader from "../../components/misc/OlogaPageHeader";
import styled from "@emotion/styled";
import { Box, spacing } from "@mui/system";
import OlogaDataGrid from "../../components/tables/OlogaDataGrid";
import DemandMappingForm from "./DemandMappingForm";
import { OlogaButton } from "../../components/Buttons/OlogaButton";
import OlogaTextfield from "../../components/inputfields/OlogaTextField";
import { Formik } from "formik";
import http from "../../utils/axios";
const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "50%",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};
interface dropdownDTO {
  text: string;
  value: number;
}

interface SearchDTO {
  sector: string;
  description: string;
}

const ToolDemandMapping: React.FC = () => {
  const Card = styled(MuiCard)(spacing);
  const navigate = useNavigate();
  const [openFeedbackModal, setOpenFeedbackModal] = useState(false);
  const [demandDto, setDemandDto] = useState({});
  const handleOpenFeedbackModal = () => setOpenFeedbackModal(true);
  const handleCloseFeedbackModal = () => setOpenFeedbackModal(false);
  const [selectedName, setSelectedName] = useState("");
  const [selectedSector, setSelectedSector] = useState("");
  const [selectedProvince, setSelectedProvince] = useState("");
  const [sectors, setSectors] = useState<dropdownDTO[]>([]);
  const [dropdown_province, setDropdown_province] = useState<dropdownDTO[]>([]);
  const [url, setUrl] = useState("/demand/page");
  const columns: GridColDef[] = [
    {
      field: "name",
      headerName: "Descrição do Projecto/Oportunidade",
      flex: 3,
      editable: false,
    },
    {
      field: "province",
      headerName: "Provincia",
      flex: 1.5,
      editable: false,
    },
    {
      field: "district",
      headerName: "Distrito",
      flex: 1.5,
      editable: false,
    },
    {
      field: "subActivitySector",
      headerName: "Sub-Sector de Actividade",
      flex: 2,
      editable: false,
    },
    {
      field: "startDate",
      headerName: "Data de Inicio",
      flex: 1,
      editable: false,
    },
    {
      field: "endDate",
      headerName: "Data de Fim",
      flex: 1,
      editable: false,
    },
    {
      field: "actions",
      headerName: "Acções",
      flex: 1.5,
      editable: false,
      type: "actions",
      getActions: (params) => [
        <GridActionsCellItem
          icon={<OlogaButton variant="outlined" label="Editar" />}
          onClick={async () => {
            console.log(params.row);
            setDemandDto(params.row as any);
            handleOpenFeedbackModal();
          }}
          label="Editar"
        />,
      ],
    },
  ];

  useEffect(() => {
    const fetchData = async () => {
      try {
        const responseSectors = await http.get(
          `simple-entity/findDropdown/ACTIVITY_SECTOR`
        );
        setSectors(responseSectors.data);

        const responseProvinces = await http.get(
          `simple-entity/findDropdown/PROVINCE`
        );
        setDropdown_province(responseProvinces.data);
      } catch (error) {
        console.error("Erro ao carregar dados:", error);
      }
    };

    fetchData();
  }, []);

  const handleSubmit = async (values: any) => {
    try {
      const params = new URLSearchParams();

      if (selectedName) params.append("name", selectedName);
      if (selectedSector) params.append("subActivitySector", selectedSector);
      if (selectedProvince) params.append("province", selectedProvince);

      setUrl(`/demand/page?${params.toString()}`);
    } catch (error: any) {
      toast.error(
        "Ocorreu o seguinte erro ao realizar a operação: " + error.message
      );
    }
  };

  return (
    <React.Fragment>
      <OlogaPageHeader
        title={"Mapeamento de Demanda"}
        buttonLabel="Adicionar Nova Demanda"
        onClick={handleOpenFeedbackModal}
      ></OlogaPageHeader>
      <Grid container>
        <Grid item xs={12}>
          <Formik initialValues={{}} enableReinitialize onSubmit={handleSubmit}>
            {({ handleSubmit }) => (
              <form onSubmit={handleSubmit}>
                <Grid container spacing={4} mb={3}>
                  <Grid item xs={12} md={3}>
                    <OlogaTextfield
                      name="name"
                      label="Descrição do Projeto"
                      value={selectedName}
                      onChange={(e) => setSelectedName(e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <OlogaTextfield
                      name="subActivitySector"
                      label="Setor de Atividade"
                      value={selectedSector}
                      onChange={(e) => setSelectedSector(e.target.value)}
                      select
                      SelectProps={{
                        native: true,
                      }}
                    >
                      <option value="">Selecione um setor</option>
                      {sectors.map((sector) => (
                        <option key={sector.value} value={sector.text}>
                          {sector.text}
                        </option>
                      ))}
                    </OlogaTextfield>
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <OlogaTextfield
                      name="province"
                      label="Província"
                      value={selectedProvince}
                      onChange={(e) => setSelectedProvince(e.target.value)}
                      select
                      SelectProps={{
                        native: true,
                      }}
                    >
                      <option value="">Selecione uma província</option>
                      {dropdown_province.map((province) => (
                        <option key={province.value} value={province.text}>
                          {province.text}
                        </option>
                      ))}
                    </OlogaTextfield>
                  </Grid>
                  <Grid item xs={12} md={2}>
                    <OlogaButton
                      type="submit"
                      icon={<SearchIcon />}
                      label="Pesquisar"
                    />
                  </Grid>
                </Grid>
              </form>
            )}
          </Formik>
        </Grid>
        <Grid item xs={12}>
          <Card>
            <OlogaDataGrid url={url} columns={columns} />
          </Card>

          <Modal open={openFeedbackModal} onClose={handleCloseFeedbackModal}>
            <Box sx={style}>
              <Typography variant="h6" component="h2" mb={2}>
                Formulário de Mapeamento de Demanda
              </Typography>
              <DemandMappingForm
                onClose={handleCloseFeedbackModal}
                dto={demandDto}
              />
            </Box>
          </Modal>
        </Grid>
      </Grid>
    </React.Fragment>
  );
};

export default ToolDemandMapping;
